import React from 'react'
import AboutUs from '../about-us'

const AboutUsSv = () => {
    return <AboutUs languageCode="sv" />
}

export default AboutUsSv
